









import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';

@Component
export default class ParametersParameterFilterList extends BaseComponent {
  public filter: any = {
    term: '',
  };

  public onFilter(): void {
    this.$emit('filter', this.filter);
  }
}
